/*
 * @Author: ç¯çç§æ(lucas huang)
 * @Date: 2018-11-23 11:23:12
 * @LastEditors: ç¯çç§æ(Lucas Huang)
 * @LastEditTime: 2020-10-20 20:18:26
 * @Company: Inspur
 * @Version: v0.3.x
 */

import {Component, Input, ViewChild, OnChanges, SimpleChanges,
EventEmitter,OnInit,Injector,ComponentFactoryResolver,
Output,ChangeDetectorRef,ViewEncapsulation,AfterViewInit,ViewContainerRef,
forwardRef,ComponentRef,Type,ElementRef,NgZone,Renderer2,OnDestroy,HostListener,} from "@angular/core";

import { NG_VALUE_ACCESSOR } from "@angular/forms";
import { Observable, Subscription, of, Subject, BehaviorSubject } from "rxjs";

import { LocaleService } from "@farris/ui-locale";
import { IResizeEvent } from "@farris/ui-draggable";
import { MessagerService } from "@farris/ui-messager";
import { LoadingService, LoadingComponent } from "@farris/ui-loading";
import { DataTableComponent } from "@farris/ui-datatable";
import { TreeTableComponent, TreeNode } from "@farris/ui-treetable";
import { LayoutComponent, LayoutPanelComponent } from "@farris/ui-layout";
import { CommonUtils, DebugService, FarrisComponentInstanceService, OverLayHiddenService } from "@farris/ui-common";
import { EntityFilter, FilterCondition } from "@farris/ui-common/types";
import { ShortcutsService } from "@farris/ui-shortcuts";
import { InputGroupComponent } from "@farris/ui-input-group";
import { NotifyService } from "@farris/ui-notify";

import {
    FAVORITE_FIELD_NAME,
    INPUT_GROUP_ICON,
    LookupGridDisplayType,
    ExtInfoFormatter,
    CustomDataFormatter,
    QuickSelectOption,
    QuickSelectDefaultOptions,
    SearchBarMode,
} from "./lookup-displaytype";
import { LookupComponent } from "./lookup.component";
import {
    LookupGridOptions,
    lookupGridDefaults,
    LookupGridResult,
    NavigationOptions,
    DisplayInfo,
    displayInfoDefault,
    PickingResult,
    TreeInfo,
    LOAD_DATA_TYPE,
    ONLY_SELECT_LEAF,
    PersonalConfig} from "./lookup-grid-options";
import { ILookupHttpService, ServerSideToken } from "./http/ILookupHttpService";
import { NavigationFilter } from "./http/RemoteParams";
import { LookupLeftComponent } from "./lookup-left.component";
import { LookupDefaultMapping } from "./lookup-defaut-mapping";
import { LookupUtils } from "./utils";
import { PersonalConfigService } from "./lookup-presonalConfig.service";
import {
    UtilService,
    TreeNodeHelper,
    FavoriteHelper,
    SelectionManager,
    DataTableEventManager,
    TreeTableEventManager,
    MultiSelectionManager,
    LookupHttpManager,
    LookupComponentManager,
    LookupDialogManager,
    onTextChanged,
    LookupSelectionService,
} from "./services";
import { catchError, map, switchMap } from "rxjs/operators";

import { EventManager } from "@angular/platform-browser";
import { cloneDeep } from "lodash-es";
import { SingleSelectDirective } from "@farris/ui-forms";

export const LOOKUPGRID_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => LookupGridComponent),
    multi: true,
};

@Component({
    selector: "farris-lookup-grid",
    templateUrl: "./lookup-grid.component.html",
    styleUrls: ["./lookup-grid.component.scss"],
    providers: [
        LOOKUPGRID_VALUE_ACCESSOR,
        ShortcutsService,
        LookupDefaultMapping,
        LookupUtils,
        PersonalConfigService,
    ],
    encapsulation: ViewEncapsulation.None,
    exportAs: "lookup"
})
export class LookupGridComponent
    extends LookupComponent
    implements OnInit, AfterViewInit, OnChanges, OnDestroy
{
    groupIcon = INPUT_GROUP_ICON;
    _displayType = "";

    /** ä½¿ç¨è¡¨åè®¾è®¡å¨ä¸­çæ¾ç¤ºç±»åãå¦åä½¿ç¨åæ°æ®è®¾ç½®çæ¾ç¤ºç±»åã é»è®¤ï¼false */
    @Input() customDisplayType = false;
    @Input() viewType: "text" | "tag" = "text";
    @Input()
    get displayType() {
        return this._displayType;
    }
    set displayType(val: string) {
        if (val) {
            const types = Object.values(LookupGridDisplayType);
            const i = types.findIndex((n) => n === val.toUpperCase());
            if (i > -1) {
                const keys = Object.keys(LookupGridDisplayType);
                this._displayType = LookupGridDisplayType[keys[i]];
            }
        } else {
            this._displayType = val;
        }
    }
    /** å¯ç¨æ¸ç©ºæé® */
    @Input() enableClear = true;
    /** æå¡å¨ç«¯æåº */
    @Input() remoteSort = true;

    @Input() condition: EntityFilter;
    @Input() conditions: Array<FilterCondition>;

    /** æ è¡¨æ¾ç¤ºå¨éå¤éæ¡ã é»è®¤ä¸æ¾ç¤º */
    @Input() showCheckAll = false;

    /** å¯ç¨åéï¼é»è®¤ä¸º true, å¦åä¸º å¤é */
    @Input() singleSelect = true;
    /** å¤éåéç¬¦, é»è®¤ä¸º , */
    @Input() multipleChoiceSeparator = ",";
    /** ä¸»é®å­æ®µ */
    @Input() idField?: string;
    /** å¯ä»¥ä¸ºåæ°æ®IDãwebapiURL */
    @Input() uri?: string = '';
    /**
     * BE REST RUI
     * - æ­¤å¤è®¾ç½®å uri å¤±æ
     */
    @Input() beUri = "";
    /**
     * æ¾ç¤ºè¿æ»¤å·¥å·æ¡; é»è®¤ true
     */
    @Input() showFilterBar = true;
    /** æ¯å¦å¯ç¨åé¡µ */
    @Input() pagination = true;
    /** å½åé¡µç´¢å¼ï¼ä» 1å¼å§ */
    @Input() pageIndex = 1;
    /** æ¯é¡µè®°å½æ° */
    @Input() pageSize = 20;
    /** å¯ç¨åé¡µè®°å½æ°åè¡¨ */
    @Input() pageList = [10, 20, 30, 50, 100];
    /** æ»è®°å½æ° */
    @Input() total = 0;
    /** å¯æå¨å */
    // @Input() resizableColumns = true;
    /** æ¾ç¤ºåä¿¡æ¯, é»è®¤ä¸º [] */
    @Input() columns: any[] = [];

    /** å¸®å©æ¥è¯¢æ¯å¦ä¸ºè¿ç«¯æ¥è¯¢ */
    @Input() remoteSearch = true;

    /** ææ¬åååï¼è¿è¡æå¡å¨ç«¯æ¥è¯¢ */
    @Input() searchOnServer = true;
    /** ä¸è¿è¡æå¡å¨æ¥è¯¢ï¼æå¥ç®å¥ */
    @Input() nosearch = false;

    /**
     * å¯ç¨ä»»æè¾å¥åï¼å¼éè¿è¾å¥æ¶è§¦å
     */
    @Output() clearMappings = new EventEmitter();

    /**
     * åè®¸è¾å¥çå­ç¬¦æå¤§é¿åº¦ã
     * ä»»æè¾å¥æ¶ï¼æ­¤å±æ§ææ
     */
    @Input() maxLength;

    @Input() mappingFn: (rowData, mapFields, bindingData?: any) => void;
    /** æ°æ®åè¡¨ */
    @Input() items: any;
    // æ¶èåè¡¨
    @Input() favoriteItems: any[] = [];
    /** èªå®ä¹æ°æ® */
    @Input() customData: any;

    /** ç»å®å¼æå¨çå¯¹è±¡ */
    @Input() bindingData: {};

    @Input() treeInfo: TreeInfo;
    /** æ¯å¦å¯ç¨çº§èéæ©æ§å¶éé¡¹ */
    @Input() enableCascade = false;
    /** çº§èæ§å¶é»è®¤å¼ï¼ enable: åæ­¥éæ©, upï¼åå«ä¸çº§, downï¼åå«ä¸çº§, disableï¼ä»éæ©èªèº« */
    @Input() cascadeStatus: "enable" | "up" | "down" | "disable" = "enable";
    /** åå«çº§èéé¡¹çå¯ç¨ç¶æï¼é»è®¤å¨é¨å¯ç¨ */
    @Input() cascadeItems = {
        enable: true,
        up: true, 
        down: true,
        disable: true
    }
    /** æ¾ç¤ºçº§èæ§å¶ */
    @Input() showCascadeControl = true;

    @Input() placeholder = "";

    /** æ¾ç¤ºå·²éè®°å½åè¡¨ã é»è®¤ä¸º false ä¸æ¾ç¤º */
    @Input() showSelected = false;

    /** åºç¨æ¶èå¤¹ */
    @Input() useFavorite = false;
    /** ä¸ªæ§åæ°æ®KEYï¼ æ¶èæ°æ®ï¼çªå£å¤§å°ï¼å½åtabé¡µ */
    @Input() favoriteKey: string = null;
    /** æ¶èæ°æ®æ¥èªäºï¼ locale: æ¬å°å­å¨ï¼ remote: æå¡å¨ç«¯å­å¨ */
    @Input() favoriteDataFrom: "locale" | "remote" = "remote";
    /** ä½¿ç¨æç¤º,å¿«æ·éæ© */
    @Input() useTip = false;
    /** è®°å½çªå£å¤§å° */
    @Input() isRecordSize = false;

    /** å¿«ééæ© */
    @Input() userId: string;

    /** æ¯å¦å¯ç¨éä¸­valueå¼å¯¹åºçè¡æ°æ®ï¼é»è®¤ true */
    @Input() enableToSelect = true;

    @Input() enableFindText = false;
    /** -1: ä¸å±å¼ï¼ 0: å¨é¨å±å¼ï¼>0: å±å¼å°æå®çº§æ° */
    @Input() expandLevel = -1;

    @Input() navTreeTableOptions: any = {};
    @Input() treeTableOptions: any = {};
    @Input() dataTableOptions: any = {};


    defaultTreeTableOptions = {
        maxLevel: 9,
        enableContextMenu: false,
        contextMenuItems: [],
    };

    /** æ å½¢å¸®å©æ°æ®å è½½æ¹å¼ï¼ default: åç½®åæ°ï¼ loadall: å è½½ææ layerloadï¼åå±å è½½ */
    @Input() loadTreeDataType: "default" | "loadall" | "layerload" = "default";

    /** çªå£æå¼åç«å³å è½½æ°æ®ï¼é»è®¤ä¸º true */
    @Input() loadDataWhenOpen = true;

    /**
     * å¯¼èªåè¡¨ï¼æ åè¡¨å¨å¸®å©æå¼åéä¸­çæ°æ®;
     * è®¾ç½®åï¼`selectFirstInNav` å¤±æï¼
     */
    @Input() navSelectedIds = "";

    /**
     * å¯¼èªå¸®å©ï¼éä¸­ç¬¬1æ¡æ°æ®ï¼é»è®¤ä¸º false;
     * æ³¨æï¼å½`navSelectedIds`ä¸ä¸ºç©ºæ¶ï¼æ­¤å±æ§å¤±æã
     */
    @Input() selectFirstInNav = false;

    /** å¯ç¨æé å®æ´æ è¿æ»¤ */
    @Input() enableFullTree = true;

    /** æ¾ç¤ºææ¬èªå®ä¹å½æ° */
    @Input() displayFormatter: (
        value: string,
        data: any,
        instance: any
    ) => string = undefined;
    /** æ¾ç¤ºææ¬å­æ®µéåï¼ä»¥ è±æ éå·éå¼ */
    @Input() displayFields = "";
    @Input() displayTextSeparator = "_";

    /**
     * å¸®å©åæ°æ®IDï¼ä¸ä¸ºç©ºæ¶è°ç¨æå®çURI
     * /api/runtime/bcc/v1.0/help/data/{helpId}
     */
    @Input() helpId = "";
    /** ææ¬å¯¹é½æ¹å¼ï¼ left | center | right; é»è®¤ left */
    @Input() textAlign = "left";

    /** é¼ æ æ»è¿è¾å¥æ¡æ¶æ¾ç¤ºè¾å¥æ¡åçææ¬ä¿¡æ¯ */
    @Input() enableTitle = true;
    @Input() useExtendInfo = false;
    @Input() extInfoFields = "";
    @Input() extInfoFormatter: ExtInfoFormatter;
    @Input() extendInfo = "";
    /** IDE è®¾è®¡å¨èªå®ä¹æ ¼å¼å 2103 */
    @Input() customFormatter: CustomDataFormatter = null;
    @Input() customNavFormatter: CustomDataFormatter = null;

    /** èªå®ä¹ç¡®å®äºä»¶ */
    @Input() okHandler = null;
    /** èªå®ä¹åæ¶äºä»¶ */
    @Input() cancelHandler = null;

    @Input() tagboxHeight = "auto";
    @Input() maxTagboxHeight;

    /** å¯ç¨è·åææå­çº§æ°æ®çåè½,ä»æ¯æåçº§ç  */
    @Input() enableGetAllChildNodes = true;

    // ilink 497076
    // private _useReturnAllChildNodes = false;
    // /** è·åææå­çº§æ°æ®ï¼é»è®¤ä¸º false */
    // get useReturnAllChildNodes() {
    //     return this._useReturnAllChildNodes;
    // }
    // @Input() set useReturnAllChildNodes(val: boolean) {
    //     this._useReturnAllChildNodes = val;
    //     this.isGetAllChidlNodes = val;
    // }

    @Input() shortcutKey = {
        /** æå¼å¸®å©çªå£ */
        open: "ArrowRight",
        /** ç¡®è®¤éæ©æ°æ® */
        confirm: "Enter",
        /** æç´¢æ¡ç¦ç¹ */
        searchFocus: "F3",
        /** éä¸­ä¸ä¸æ¡ */
        moveUp: "ArrowUp",
        /** éä¸­ä¸ä¸æ¡ */
        moveDown: "ArrowDown",
        /** å±å¼èç¹ */
        expand: "ArrowRight",
        /** æå èç¹ */
        collapse: "ArrowLeft",
        /** ä¸ä¸é¡µ */
        nextPager: "PageDown",
        /** ä¸ä¸é¡µ */
        prevPager: "PageUp",
    };
    /** å¿«æ·éæ©ç¸å³éç½®é¡¹ï¼é»è®¤ä¸º null, å³ä¸å¯ç¨æ­¤åè½ */
    @Input() quickSelect: QuickSelectOption = null;

    /** æ å½¢å¸®å© æ¯å¦ä½¿ç¨æ å½¢ç»ææ°æ®ãé»è®¤ä¸º true, å½ä¸º false æ¶ï¼æå¡å¨ç«¯æ é¡»æé æ å½¢ç»æï¼ææ®éåè¡¨è¾åº */
    @Input() treeToList = false;
    @Input() navTreeToList = false;

    /** å¸¦å¯¼èªçå¸®å©ä¸­ï¼æ¯å¦æ¾ç¤ºå·¦ä¾§å¯¼èªé¨åãé»è®¤ true */
    @Input() showNavigation = true;

    /** å·¦ä¾§æ å¯¼èªæ¯å¦æ¾ç¤º åå«ä¸çº§ï¼é»è®¤ä¸º true */
    @Input() showChildControl = true;

    /** æ°æ®éæ©åï¼å¼æ å°åè§¦å
     * è¿å Observable
     *      canSelect: <boolean>  æ¯å¦åè®¸éæ©
     *      message: <string> ä¸åè®¸éæ©æ¶çæç¤ºä¿¡æ¯
     */
    @Input() beforeSelectData: (p: {
        instance: any;
        data: any;
    }) => Observable<{ canSelect: boolean; message: string } | boolean>;

    @Input() beforeLoadData: (p: { instance: any, res: LookupGridResult }) => Observable<LookupGridResult>;

    /** æ¯å¦å¯ç¨æ°å¸å±
     * - é»è®¤ false */
    @Input() useNewLayout = false;

    /** å¯ç¨å¤å­æ®µæ¥è¯¢ é»è®¤ä¸º false
     * - å¯ç¨æ­¤ç¹æ§åï¼useNewLayout èªå¨å¯ç¨
     */
    @Input() enableMultiFieldSearch = false;
    /** æç´¢å·¥å·æ¡æ¾ç¤ºæ¨¡å¼ï¼ both: å¨é¨æ¾ç¤ºï¼onlyfield: ä»æ¾ç¤ºå­æ®µï¼onlyinput: ä»æ¾ç¤ºæç´¢è¾å¥æ¡ãé»è®¤ both */
    @Input() searchBarMode: SearchBarMode = SearchBarMode.both;
    /** åè®¸æ¥è¯¢çå­æ®µï¼ä»å¯ç¨å¤å­æ®µæ¥è¯¢æ¶ææï¼å¤ä¸ªå­æ®µä»¥ â,â éå¼ï¼  
     *  - nav å·¦ä¾§å¯¼èªå­æ®µï¼main ä¸»æ°æ®å­æ®µ;
     *  - é»è®¤ä¸º null, å³ä»æææ¾ç¤ºåä¸­èªå¨æå
     */
    @Input() allowQueryFields:{ nav?: string, main: string } = null;

    @Input() labels = {
        /** æ°æ®åè¡¨*/
        dataTab: '',
        /** æ¶èå¤¹ */
        favTab:'',
        /** åæ¶å·²é */
        clearAllSelected: '',
        /** å·²éè®°å½é¢æ¿ä¸­ å é¤å·²é */
        delSelected: ''
    }

    @Input() enableEqualSearch = false;
    @Input() searchType = 'like';

    /** åè®¸ä»»æå­æ®µè¿è¡æ¥è¯¢ï¼ é»è®¤ true */
    @Input() searchAnyField = true;

    @Output() selectedData = new EventEmitter();
    @Output() clear = new EventEmitter();
    /** æªå¯ç¨å¤å­æ®µæ¥è¯¢æ¶è§¦å */
    @Output() search = new EventEmitter();
    /** å¯ç¨å¤å­æ®µæ¥è¯¢æ¶è§¦å */
    @Output() query  = new EventEmitter();
    // å¸®å©ææ¬æ¡ä¸­å¼ååäºä»¶
    @Output() valueChanged = new EventEmitter();
    @Output() loadSuccess = new EventEmitter();

    @Output() pagerChanged = new EventEmitter();

    @Output() expandTreeNode = new EventEmitter();
    @Output() textChanged = new EventEmitter();

    @Output() checkedChange = new EventEmitter<{
        data: any;
        isCheck: boolean;
    }>();

    @Output() tagRemoved = new EventEmitter();

    /** åå®¹ä¸­çç½è¾¹è· */
    containerMargin = { top: 0, bottom: 5, left:  14, right: 14 };
    containerStyle = {
    };

    _gridOptions: LookupGridOptions = lookupGridDefaults;

    get gridOptions() {
        if (
            this.useFavorite &&
            this.columns &&
            this.columns.length > 0 &&
            !this.columns.find((item) => item.field === FAVORITE_FIELD_NAME)
        ) {
            this.columns.push({
                field: FAVORITE_FIELD_NAME,
                title: "",
                width: 40,
                align: "center",
                fixed: 'right',
                // fixedWidth: true,
                formatter: this.favHelper.favoriteColumnFormatter,
            });
        }

        this._gridOptions = Object.assign(this._gridOptions, {
            singleSelect: this.singleSelect,
            idField: this.idField,
            uri: this.uri,
            showFilterBar:  this.enableMultiFieldSearch? false: this.showFilterBar,
            pagination: this.pagination,
            pageIndex: this.pageIndex,
            pageSize: this.pageSize,
            pageList: this.pageList,
            total: this.total,
            items: this.items,
            columns: this.columns,
            resizableColumns: true,
            fixedHeader: true,
            hover: true,
            treeInfo: this.treeInfo,
            searchAnyField: this.searchAnyField
        });

        return this._gridOptions;
    }
    @Input() set gridOptions(opts) {
        this._gridOptions = Object.assign({}, this._gridOptions, opts);
        // this.selectedColumns = this.multiSelMgr.initSelectedColumns();
    }

    @ViewChild("contentContainer", { read: ViewContainerRef })
    contentContainer: ViewContainerRef;
    @ViewChild("favoritesContainer", { read: ViewContainerRef })
    favoritesContainer: ViewContainerRef;
    @ViewChild("leftContainer", { read: ViewContainerRef })
    leftContainer: ViewContainerRef;
    @ViewChild("centerContainer", { read: ViewContainerRef })
    centerContainer: ViewContainerRef;
    @ViewChild("multiSelectDT") selectedDtRef: DataTableComponent;
    @ViewChild("inputgroup") inputGroup: InputGroupComponent;
    @ViewChild("leftPanel") leftPanel: LayoutPanelComponent;
    @ViewChild("tagbox") tagbox: ElementRef;

    @ViewChild("okbtn") okButton: ElementRef;
    @ViewChild("tagInput") tagInput: InputGroupComponent;

    @ViewChild('selectedpanel') selectedpanel: ElementRef;
    @ViewChild('cascadeSelect') cascadeSelect: SingleSelectDirective;
    @ViewChild('layout') layoutRef: LayoutComponent;

    componentRef: ComponentRef<any>;
    leftComponentRef: ComponentRef<LookupLeftComponent>;
    favoritesComponentRef: ComponentRef<any>;

    public http: ILookupHttpService;
    public messagerService: MessagerService;
    public loadingService: LoadingService;
    loading: LoadingComponent;
    // dataFieldMaps: any;
    navigationOptions: NavigationOptions;

    // å¯¼èªå¸®å©å·¦åå®½åº¦
    leftPanelWidth = 320;
    // å¯¼èªå¸®å©çªå£æå°å®½åº¦
    navLookupDialogMinWidth = 960;

    navigationFilter: NavigationFilter = null;

    subscriptions: Subscription[] = [];
    dialogOpenedSubscription: Subscription;
    dialogClosedSubscription: Subscription;

    isTextChange = false;
    isTabChanged = false;

    displayInfo: DisplayInfo = Object.assign({}, displayInfoDefault);

    tabChangeSubscription = null;
    // æå­è¡ç¹å»æ°æ®  ç¨äºæ¶è
    personalConf: PersonalConfig = {};
    favoriteColumns: any[] = [];
    /** ä¸´æ¶æ¥è¯¢åæ° */
    _searchState = null;
    allData: any = [];
    get selections() {
        const selectItems = this.lookupSelectionSer.getSelections();
        if (this.singleSelect) {
            return selectItems[0];
        } else {
            return selectItems;
        }
    }
    get usePersionalConf() {
        return this.useFavorite || this.useTip || this.isRecordSize;
    }

    get displayTextList() {
        if (this.displayText) {
            return this.displayText.split(this.multipleChoiceSeparator);
        }
        return [];
    }

    public personalConfigService: PersonalConfigService;
    public utilService: UtilService;
    public treeNodeHelper: TreeNodeHelper;
    public localService: LocaleService;
    public notifyService: NotifyService;
    allColumnsTitle = "ææå";
    mustWriteSomething = "è¯·è¾å¥å³é®å­åæ¥è¯¢ã";
    mustChoosAdatarow = "è¯·éæ©ä¸æ¡è®°å½ï¼";
    addFavoriteSuccess = "æ¶èæåã";
    delFavoriteSuccess = "ç§»é¤æ¶èæåã";

    /** ä½¿ç¨åç½®çæ¥è¯¢æ¹æ³, é»è®¤ false */
    useInsideSearchHandler = false;
    searching = false;
    /** ä¸´æ¶å­å¨æ¥è¯¢ç»æé */
    _searchResult = null;

    lookupinitializationSubject = new Subject();

    /** å¤éæ¶ï¼éä¸­çæ°æ® */
    currentSelectedItems: Observable<any> = of([]);
    /** å·²éæ°æ®åä¿¡æ¯ */
    selectedColumns = [];
    activeTab: string | "datalist" | "favorite" | "selected" = "datalist";

    favHelper: FavoriteHelper = null;
    ttEventMgr: TreeTableEventManager = null;
    multiSelMgr: MultiSelectionManager = null;
    httpMgr: LookupHttpManager = null;
    lookupCmpMgr: LookupComponentManager = null;
    dialogMgr: LookupDialogManager = null;
    selectionMgr: SelectionManager = null;
    dtEventMgr: DataTableEventManager = null;

    lookupSelectionSer: LookupSelectionService = null;

    controlId = "";
    savingFaoriteData = false;
    isReady = false;
    showTagboxClearButton = false;
    hasError = false;

    cascadeStatusItems = [
        { valeu: 'enable', label: '' },
        { valeu: 'up', label: '' },
        { valeu: 'down', label: '' },
        { valeu: 'disable', label: '' }
    ]

    isGetAllChidlNodes = false;
    eventManager: EventManager;
    /** éä¸­è®°å½IDï¼èªå®ä¹å¸®å©åæ°æ¶ä½¿ç¨ */
    selectedIds = [];
    private lookupSearchInputEvent = null;
    private farrisInstances: FarrisComponentInstanceService = null;
    /** ç¨æ·åå§è®¾ç½® */
    private _userSettings: any = {};

    get userInitialConfig() {
        return this._userSettings;
    }

    _treeInfo_ = null;

    /** dialog åå®¹åºåé«åº¦ã å¼¹çªæ»é«åº¦ - å¤´é¨é«åº¦ - èé¨é«åº¦ - ï¼å¯ç¨æ¶è TABå¤´é«åº¦ï¼ */
    dialogContentHeight = 0;
    /** å·¦æ å³åè¡¨ï¼ å·¦æ ç¹å»èç¹æ¥è¯¢æ¶æ¯å¦åæ¬ä¸çº§èç¹çæ°æ®ï¼é»è®¤ false */
    includeSubordinates = false;
    includeSubordinates$ = new Subject();
    includeSubordinates$$: Subscription = null;
    overLayService: OverLayHiddenService;
    private debugSer: DebugService = null;
    constructor(
        public injector: Injector,
        public cfr: ComponentFactoryResolver,
        public el: ElementRef,
        public utils: CommonUtils,
        private defaultMapping: LookupDefaultMapping,
        public changeDetector: ChangeDetectorRef,
        public shortcuts: ShortcutsService,
        public lookupUtils: LookupUtils,
        private zone: NgZone,
        public render2: Renderer2
    ) {
        super(injector, el, changeDetector);
        this.createInstance();
        this.currentSelectedItems = this.lookupSelectionSer.selected$;
        this.eventManager = this.injector.get(EventManager);
        this.farrisInstances = this.injector.get(
            FarrisComponentInstanceService,
            null
        );

        this.overLayService = new OverLayHiddenService();

        this.debugSer = this.injector.get(DebugService, null);
        if (this.debugSer) {
            this.debugSer.useDebugMode();
        }

        this.lookupSelectionSer.selectionChanged$.subscribe((e: {data: Array<any>, selected: boolean}) => {
            if (this.selectedDtRef) {
                if (!e.selected) {
                    this.selectedDtRef.unCheckRows(e.data);
                }
            }
        });

        this.initLabels();
    }

    private initLabels() {
        if (!this.labels) {
            this.labels = {
                /** æ°æ®åè¡¨*/
                dataTab: '',
                /** æ¶èå¤¹ */
                favTab:'',
                /** åæ¶å·²é */
                clearAllSelected: '',
                /** å·²éè®°å½é¢æ¿ä¸­ å é¤å·²é */
                delSelected: ''
            }
        }
        if (!this.labels.clearAllSelected) {
            this.labels.clearAllSelected = this.localService.getValue('lookup.selectedInfo.clear');
        }

        if (!this.labels.favTab) {
            this.labels.favTab = this.localService.getValue('lookup.favorites');
        }

        if (!this.labels.dataTab) {
            this.labels.dataTab = this.localService.getValue('lookup.datalist');
        }

        if (this.searchAnyField == null) {
            this.searchAnyField = true;
        }
    }

    writeConsole(msg, type: 'info'|'log'|'warn'|'error' = 'warn') {
        if (this.debugSer) {
            this.debugSer[type](msg);
        }
    }

    getFilterBarHeight() {
        return (this.showFilterBar && this.enableMultiFieldSearch ? 42 : 0);
    }

    getSpaceWidth(isDouble = false) {
        return (!this.enableMultiFieldSearch ? 28 : 48) + (isDouble ? ( this.enableMultiFieldSearch? 5: 7) : 0);
    }

    private cacheUserConfig() {
        this._userSettings._title = this.title;
        this.displayInfo.title = this.title;
        this._userSettings._columns = this.deepClone(this.columns || []);
        this._userSettings.getColumns = () => {
            return this._userSettings._columns;
        };

        this._userSettings.reset = () => {
            this.title = this._userSettings._title;
            this.displayInfo.title = this.title;
            this.columns = this._userSettings.getColumns();
        };
    }

    private deepClone(obj) {
        if (obj === null) {
            return null;
        }
        const clone = Object.assign({}, obj);
        Object.keys(clone).forEach(
            (key) =>
                (clone[key] =
                    typeof obj[key] === "object"
                        ? this.deepClone(obj[key])
                        : obj[key])
        );
        if (Array.isArray(obj)) {
            clone.length = obj.length;
            return Array.from(clone);
        }
        return clone;
    }

    ngOnInit() {
        super.ngOnInit();
        this.cacheUserConfig();
        if (!this.loadTreeDataType) {
            this.loadTreeDataType = "default";
        }

        this.checkGridOptions();
        this.displayInfo.title = this.title;
        /** ä¼ éä¸ä¸æ */
        if (this.http) {
            this.http.context = this.context;
        }

        this.allColumnsTitle = this.localService.getValue("lookup.allColumns");
        this.mustWriteSomething = this.localService.getValue(
            "lookup.mustWriteSomething"
        );
        this.mustChoosAdatarow = this.localService.getValue(
            "lookup.mustChoosAdatarow"
        );
        this.addFavoriteSuccess =
            this.localService.getValue("lookup.favoriteInfo.addFav") ||
            this.addFavoriteSuccess;
        this.delFavoriteSuccess =
            this.localService.getValue("lookup.favoriteInfo.cancelFav") ||
            this.delFavoriteSuccess;

        this.dialogMgr.onDialogCreated();

        this._treeInfo_ = this.treeInfo ? cloneDeep(this.treeInfo) : null;

        if (this.quickSelect) {
            this.quickSelect = Object.assign({}, QuickSelectDefaultOptions, this.quickSelect || {});
        }
        this.setContainerMargin();
    }
    /** åå®¹ä¸­çç½è¾¹è· */
    setContainerMargin() {
        const mrn = !this.enableMultiFieldSearch ? 14 : 24;
        const mb =  !this.enableMultiFieldSearch ? 5 : 0;
        this.containerMargin = { top: 0, bottom: mb, left: mrn, right: mrn };
        
        if (this.enableMultiFieldSearch) {
            this.useNewLayout = true;
        }

        this.containerStyle = {
            marginLeft: this.containerMargin.left + "px",
            marginRight: this.containerMargin.right + "px",
            marginTop: this.containerMargin.top + "px",
            marginBottom: this.containerMargin.bottom + "px",
        };
    }

    ngOnDestroy() {
        super.ngOnDestroy();
        this.subscriptions.forEach((n) => {
            if (n) {
                n.unsubscribe();
                n = null;
            }
        });

        if (this.selectionMgr) {
            this.selectionMgr.destroy();
        }

        this.subscriptions = [];

        if (this.farrisInstances) {
            this.farrisInstances.destroy(this.el.nativeElement);
        }

        if (this.lookupSearchInputEvent) {
            this.lookupSearchInputEvent();
        }
        this.lookupUtils.destroy();

        this.overLayService.destory(this.el.nativeElement);
        this.overLayService = null;
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.columns && !changes.columns.isFirstChange()) {
            this.cacheUserConfig();
        }

        if (changes.enableMultiFieldSearch && !changes.enableMultiFieldSearch.isFirstChange()) {
            this.setContainerMargin();
        }

    }

    ngAfterViewInit() {
        if (!this.quickSelect || !this.quickSelect.enable) {
            this.lookupSearchInputEvent = onTextChanged.bind(this)();
        }

        // åå§åä¸ªæ§åéç½®
        if (this.usePersionalConf) {
            this.favHelper.initPersonalInfo();
        }

        if (this.useExtendInfo) {
            const jsonData = this.selectionMgr.getBindingData();
            this.updateExtendInfo(jsonData, false);
        }

        if (this.viewType === "text") {
            // this.shortcuts.add({
            //     key: 'F2',
            //     target: this.inputGroup.textbox.nativeElement,
            //     command: () => {
            //         this.showDialog();
            //     }
            // });
            this.render2.listen(
                this.inputGroup.textbox.nativeElement,
                "keydown.F2",
                this.showDialog.bind(this)
            );
        } else {
            this.registerMouseEventForTagView();

            if (this.tagboxHeight) {
                const el =
                    this.tagbox.nativeElement.querySelector(".multi-more");
                let tbh = this.tagboxHeight;
                if (tbh !== "auto") {
                    tbh += "px";

                    if (this.maxTagboxHeight) {
                        this.render2.setStyle(
                            el,
                            "maxHeight",
                            `${this.maxTagboxHeight}px`
                        );
                    }
                }

                this.render2.setStyle(el, "height", tbh);
            }
        }

        if (this.el && this.farrisInstances) {
            this.farrisInstances.add(this.el.nativeElement, this);
        }
    }

    private createInstance() {
        this.http = this.injector.get(ServerSideToken, null);
        this.messagerService = this.injector.get(MessagerService);
        this.loadingService = this.injector.get(LoadingService);
        this.notifyService = this.injector.get(NotifyService, null);

        this.personalConfigService = this.injector.get(
            PersonalConfigService,
            null
        );

        this.lookupSelectionSer = new LookupSelectionService(this);

        this.utilService = new UtilService(this);
        this.localService = this.injector.get(LocaleService);
        this.treeNodeHelper = new TreeNodeHelper(this);

        this.favHelper = new FavoriteHelper(this);
        this.ttEventMgr = new TreeTableEventManager(this);
        this.multiSelMgr = new MultiSelectionManager(this);
        this.httpMgr = new LookupHttpManager(this);
        this.lookupCmpMgr = new LookupComponentManager(this);
        this.dialogMgr = new LookupDialogManager(this);
        this.selectionMgr = new SelectionManager(this);
        this.dtEventMgr = new DataTableEventManager(this);
    }

    showDialog(): any {
        if (this.disabled || this.readonly) {
            return false;
        }

        this.selectionMgr.initDisplayValue();
        this.dictPickingSubscription = this.dictPicking({
            instance: this,
        }).subscribe((pr: PickingResult) => {
            this.selectionMgr.initDisplayValue();
            this.dialogMgr.canOpenDialog(pr);
        });

        return false;
    }

    /** å¤æ­æ¯å¦ä¸ºååè¡¨å¸®å© */
    isDoublleList() {
        return (
           ( this.displayType === LookupGridDisplayType.NavList ||
            this.displayType === LookupGridDisplayType.NavTreeList ||
            this.displayType === LookupGridDisplayType.NavListTree) && this.showNavigation
        );
    }
    /** å¤æ­æ¯å¦æ¾ç¤ºä¸ºæ å¸®å© */
    isTree() {
        const dtyp = this.displayType.toUpperCase()
        return (
            dtyp === LookupGridDisplayType.TreeList || dtyp === LookupGridDisplayType.NavListTree
        );
    }

    /** æ è¡¨å¸®å©æ¯å¦å¯ç¨åé¡µ */
    isEnableTreePager() {
        return this.isTree() && this.treeTableOptions && this.treeTableOptions.pagination;
    }

    onResized(e: any) {
        this.resizeCmp(e.size);
        this.resized.emit(e.size);
    }

    onResizing(pos: IResizeEvent) {
        this.resizing.emit(pos.size);
        this.resizeCmp(pos.size);
        if (this.isDoublleList() && this.leftComponentRef) {
            this.leftComponentRef.instance.resize({
                width: this.leftPanel.width,
                height: this.dialogMgr.getHeight(),
            });
        }
    }

    onMaxDialog(pos: IResizeEvent) {
        this.resizeCmp(pos.size);
        if (this.leftPanel) {
            this.leftComponentRef.instance.resize({
                width: this.leftPanel.width,
                height: this.dialogMgr.getHeight(),
            });
        }
        // tfs 543132 
        // this.dialogHeight = pos.size.height;
        this.dialogContentHeight = this.dialogMgr.resetDialogContentHeight();
        this.dialogMaxed.emit(pos.size);
    }

    resizeCmp(size?: any) {
        if (!this.componentRef || !this.componentRef.instance) {
            return;
        }

        if (!size) {
            size = this.dialog.size;
        }
        const _size = {
            width:
                size.width -
                this.containerMargin.left -
                this.containerMargin.right,
            height: 0
        };

        if (this.useFavorite && this.favoritesComponentRef && this.activeTab == 'favorite') {
            _size.height = this.lookupCmpMgr.getCmpHeight(true);
            this.favoritesComponentRef.instance.resize(_size);
        } else {
            _size.height = this.lookupCmpMgr.getCmpHeight();
            if (this.isDoublleList()) {
                _size.width = size.width - this.leftPanel.width - this.getSpaceWidth(true);
            }
    
            this.componentRef.instance.resize(_size);
        }

        if (this.isRecordSize) {
            this.personalConf.size = this.dialog.size;
            this.personalConfigService.updatePersonalConfig({
                size: this.dialog.size,
            });
        }

        if (this.isDoublleList() && this.layoutRef) {
            this.layoutRef.setPanelMaxSize();
        }
    }

    private checkGridOptions() {
        if (!this.gridOptions.idField) {
            this.writeConsole("æªè®¾ç½®ä¸»é®å­æ®µ idField");
        }

        if (!this.beforeSelectData) {
            this.beforeSelectData = () => {
                return of(true);
            };
        }

        const ctxMenuLanguages =
            this.localService.getValue("lookup.contextMenu");

        this.treeTableOptions = Object.assign(
            { language: ctxMenuLanguages },
            this.defaultTreeTableOptions,
            this.treeTableOptions || {}
        );
    }

    getComponentType(): Type<any> {
        if (!this.displayType) {
            this.displayType = "LIST";
        }
        switch (this.displayType) {
            case LookupGridDisplayType.List:
            case LookupGridDisplayType.NavList:
            case LookupGridDisplayType.NavTreeList:
                return DataTableComponent;
            case LookupGridDisplayType.TreeList:
            case LookupGridDisplayType.NavListTree:
                return TreeTableComponent;
        }
    }

    showLoading(msg = "") {
        if (this.dialog && this.dialog.modalContent && !this.loading) {
            const opts = {
                container: this.dialog.modalContent,
                delay: 200,
            };

            if (msg) {
                opts["message"] = msg;
            }

            this.loading = this.loadingService.show(opts);
        } else {
            this.loading = this.loadingService.show();
        }
    }

    closeLoading() {
        if (this.loading) {
            this.loading.close();
            this.loading = null;
        }

        this.loadingService.clearAll();
    }

    getSearchColumns(resdata: any): {label: string, value: string}[] {
        const cols = resdata.columns || this.columns;
        if (resdata.searchFields) {
            return resdata.searchFields.map((sf) => {
                const c = cols.find(
                    (col) => col.field.toLowerCase() === sf.value.toLowerCase()
                );
                if (c) {
                    sf.label = c.title;
                }
                return sf;
            });
        } else if (cols) {
            return cols
                .filter((c) => c.supportSearch || c.searchField)  // tfs 808863
                .map((col) => {
                    return {
                        label: col.title,
                        value: col.field,
                    };
                });
        }
        return [];
    }

    private initOptions(resData: LookupGridResult) {
        let obser = of(true);
        if (this.activeTab !== 'favorite') { // tfs 769788
            this.gridOptions.searchFields = this.getSearchColumns(resData);
        }
        if (resData) {
            // å¦æç»ä»¶ä¸­æªè®¾ç½®æ¾ç¤ºåï¼åä½¿ç¨æå¡å¨ç«¯è¿åçè®¾ç½®ï¼ å¦åå°ä½¿ç¨ç»ä»¶ä¸­éç½®çå±ç¤ºå
            if (
                (!this.columns || !this.columns.length) &&
                resData.columns &&
                resData.columns.length
            ) {
                this.columns = resData.columns;
            }

            this.initColumnWidth(this.columns);

            this.setLookupTitleText(resData);

            if (
                this.isDoublleList() &&
                this.dialogWidth < this.navLookupDialogMinWidth &&
                !this.isRecordSize
            ) {
                this.dialogWidth = this.navLookupDialogMinWidth;
                this.dialog.reSize({ width: this.dialogWidth });
            }

            if (!this.customDisplayType) {
                // this.displayType = resData.displayType || this.displayType || 'LIST';
                // if (this.treeToList) {
                //     this.displayType = this.isDoublleList() ? ' NAVLIST ': 'LIST';
                // }
                this.changeDetector.detectChanges();
                this.lookupCmpMgr.createComponentWithServerData(resData);
            }
            

            if ( this.isDoublleList() && resData.navigation && !this.leftComponentRef) {
                this.navigationOptions = resData.navigation;
                this.navigationOptions.hover = true;
                this.navigationOptions.searchFields = this.getSearchColumns(this.navigationOptions);
                this.initColumnWidth(this.navigationOptions.columns, 'nav');

                // update columns formatter
                if (this.customNavFormatter) {
                    this.navigationOptions.columns.forEach((col) => {
                        if (this.customNavFormatter[col.field]) {
                            col.formatter = this.customNavFormatter[col.field];
                        }
                    });

                    this.navigationOptions["rowStyler"] =
                        this.customNavFormatter.rowStyler;
                    this.navigationOptions["cellStyler"] =
                        this.customNavFormatter.cellStyler;
                }
                // 20210926 æ å¯¼èªå¸®å©ä¸­ å·¦ä¾§æ æ¯æåå±å è½½
                if (this.displayType === LookupGridDisplayType.NavTreeList) {
                    let _nav_treeinfo_loadtype =
                        this.navigationOptions.treeInfo.loadDataType;
                    if (this.loadTreeDataType !== "default") {
                        _nav_treeinfo_loadtype =
                            this.loadTreeDataType === "loadall"
                                ? "all"
                                : "async";
                    }
                    this.navigationOptions.treeInfo.loadDataType =
                        _nav_treeinfo_loadtype;
                }

                obser = this.lookupCmpMgr.createLeftComponent(this.navigationOptions);
            }
        } else {
            this.lookupCmpMgr.createContent(this.gridOptions);
            this.lookupCmpMgr.createFavoriteComponent();
        }

        if (this.isTextChange) {
            this.componentRef.instance.searchData.value = this.displayText;
        } else {
            if (this._searchState && this._searchState.value) {
                this.componentRef.instance.searchData.value = this._searchState.value;
            }
        }

        // update columns formatter
        if (this.customFormatter) {
            this.columns.forEach((col) => {
                if (this.customFormatter[col.field]) {
                    col.formatter = this.customFormatter[col.field];
                }
            });

            if (this.customFormatter.rowStyler) {
                this.componentRef.instance.rowStyler = this.customFormatter.rowStyler;
            }

            if (this.customFormatter.cellStyler) {
                this.componentRef.instance.cellStyler = this.customFormatter.cellStyler;
            }
        } else {
            if (resData.customStyles) {
                const { row: rowStylers, cell: cellStylers } = resData.customStyles;

                const filterFn = (n, data) => {
                    const d = this.utils.getValue(n.field, data);
                    if (typeof d === 'boolean') {
                        if (n.value == '0' || n.value == '1' || n.value == 'true' || n.value == 'false') {
                            return d === (n.value == '0' || n.value == 'false') ? false : true;
                        }
                        return d === !!n.value;
                    }
                    return d === n.value;
                }

                if (rowStylers) {
                    this.componentRef.instance.rowStyler = ({ data }) => {
                        const styleItem = rowStylers.find(n => {
                            return filterFn(n, data);
                        });
                        if (styleItem) {
                            return styleItem.styles;
                        }

                        return null;
                    }
                }

                if (cellStylers) {
                    this.componentRef.instance.cellStyler = (e, field) => {
                        const { data } = e;
                        const styleItem = cellStylers.filter(n => n.field === field).find(t => {
                            return filterFn(t, data);
                        });

                        if (styleItem) {
                            return styleItem.styles;
                        }

                        return null;
                    }
                }

            }
        }

        // this.changeDetector.detectChanges();
        return obser;
    }

    /**
     * è®¾ç½®å¸®å©çªå£æ é¢
     */
    private setLookupTitleText(resData: LookupGridResult) {
        if (resData.displayInfo) {
            this.displayInfo = resData.displayInfo;
        }

        // å¦æèªå®ä¹æ é¢ï¼å°ä»¥æ­¤æ é¢ä¸ºåãå¦åå è½½æå¡å¨ç«¯è¿åçæ°æ®
        if (this.title && this.title !== "æ­¤å¤æ¾ç¤ºå¸®å©æ é¢") {
            this.displayInfo.title = this.title;
        }

        if (this.displayInfo && resData.title) {
            if (!this.displayInfo.title) {
                this.displayInfo.title = resData.title;
            }
        }
    }

    private showGetAllChildrenCheckbox() {
        if (this.isTree() && this.treeInfo) {
            this.enableGetAllChildNodes =
                this.treeInfo.loadDataType !== "all" && this.treeInfo.layerType === "pathcode";
        } else {
            this.enableGetAllChildNodes = false;
        }
    }

    initData() {

        const observer = {
            next: (data: LookupGridResult) => {

                if (data === false) {
                    if (!this.columns || !this.columns.length) {
                        this.closeLoading();
                        this.closeDialog();
                        if (!this.messagerService.modals || !this.messagerService.modals.length) {
                            this.notifyService.error({msg: this.localService.getValue('lookup.configError') , timeout: 3000});
                        }
                        return;
                    }
                }

                // æå¡å¨ç«¯åçéè¯¯ï¼è¿åNULL æ¶ï¼ç´æ¥å³é­çªå£
                if (data === null) {
                    this.isShow = false;
                    if (this.dialog) {
                        this.dialog.close();
                    }
                    return;
                }
                this.initOptions(data).subscribe(() => {
                    this.selectedColumns = this.multiSelMgr.initSelectedColumns();

                    if (this.usePersionalConf) {
                        if (!this.personalConfigService.getPersonalData()) {
                            this.personalConfigService.savePersonalConfig(
                                this.personalConf
                            );
                        }
                    }
                    if (!this.isTabChanged) {
                        this.lookupSelectionSer.loadSelections(
                            data.selectedItems || []
                        );
                    }

                    if (this.isDoublleList()) {
                        // å¯¼èªå¸®å©æ¶ï¼è®¾ç½®å·¦ä¾§éä¸­æ°æ®æ¶ï¼ä¸å è½½ä¸»æ°æ®åè¡¨å¤±æã
                        if (this.navSelectedIds || this.selectFirstInNav) {
                            this.loadDataWhenOpen = false;
                        }
                    }

                    if (data['activeTab'] && !this.isTabChanged) {
                        this.activeTab = 'datalist';

                        if (this.personalConf && this.personalConf.tabIndex !== this.activeTab) {
                            this.personalConf.tabIndex = this.activeTab;
                        }

                    }

                    this.loadData(data);

                    if (this.isTree()) {
                        if (this.activeTab === "datalist") {
                            const tt = this.componentRef.instance as TreeTableComponent;

                            // æ è¡¨åé¡µï¼ ç¶IDåå±æ¹å¼ä¸æ¯æåé¡µ
                            if (this.treeTableOptions && this.treeTableOptions.pagination) {
                                tt.total = data.total;
                                if (!tt.total || this.treeInfo.layerType === "parentId") {
                                    // å¦ææ»æ°ä¸º0 åä¸æ¾ç¤ºåé¡µ
                                    this.treeTableOptions.pagination = false;
                                    tt.pagination = false;
                                }
                            }
                        }
                        this.showGetAllChildrenCheckbox();

                        // if (this.personalConf && this.personalConf['useGetAllChilds'] != null) {
                        //     this.isGetAllChidlNodes = !!this.personalConf['useGetAllChilds'];
                        // }
                        this.isGetAllChidlNodes = !!this.personalConf['useGetAllChilds'];
                    }
                    this.isTextChange = false;
                    this._searchResult = null; // æ¸ç©ºä¸´æ¶æ¥è¯¢ ç»æ
                    this.closeLoading();
                    // this.isReady$.next(true);
                    this.isReady = true;
                    this.changeDetector.detectChanges();
                    this.lookupinitializationSubject.next();

                    // éçæç´¢å·¥å·æ æå¤§é¿åº¦ TFS 773743
                    this.dialog.dialogEl.nativeElement.querySelectorAll('.filter-row .search-text input').forEach(n => n.setAttribute('maxlength', 200));


                    if (this.layoutRef) {
                        this.layoutRef.setPanelMaxSize();
                    }
                });
            },
            error: (err: any) => {
                // this.isReady$.next(true);
                this.closeLoading();
                this._searchResult = null; // æ¸ç©ºä¸´æ¶æ¥è¯¢ ç»æ
                this.isTextChange = false;

                this.hasError = true;
                this.changeDetector.detectChanges();
                if (typeof err === "string") {
                    this.messagerService.error(err);
                } else {
                    if (err) {
                        if (err.Message) {
                            this.messagerService.error(err.Message);
                        } else {
                            if (err.error) {
                                this.messagerService.exception(err.error);
                            } else {
                                this.messagerService.error(
                                    "åºç¨æå¡å¨éè¯¯,è¯·èç³»ç³»ç»ç®¡çåï¼"
                                );
                            }
                        }
                    }
                }
            },
        };

        let p: any = {
            pageInfo: {
                pageSize: this.pageSize || 20,
                pageIndex: 1,
            },
        };
        let t: LOAD_DATA_TYPE = "all";
        if (this.isTextChange) {
            this._searchState = { 
                field: "*",
                value: this.displayText
            }
        }

        // åå±å è½½æ¯æè®¾ç½®å±å¼å±çº§
        if (this.isTree() || this.displayType === LookupGridDisplayType.NavTreeList) {
            if (this.expandLevel > -1 && !this.isEnableTreePager()) {
                p['expandLevel'] = this.expandLevel;
            }
        }

        if (this.isEnableTreePager()) {
            // tfs 686638
            p.pageInfo.pageSize = this.treeTableOptions.pageSize;
        }

        if (this._searchState && this._searchState.value) {
            p['search'] = this._searchState;
            t = 'search';

            // if (this.conditions && !this.conditions.length && this.enableMultiFieldSearch) {
            //     this.conditions = [{
            //         "filterField": this.textField,
            //         "value": this._searchState.value,
            //         "lbracket": "",
            //         "rbracket": "",
            //         "relation": 0,
            //         "compare": 6
            //     }];
            // }
        }


        if (!this.isTabChanged && this.enableToSelect) {
            const vals = this.selectionMgr.getSelectedIds();
            if (vals && vals.length) {
                p["selectedInfo"] = {
                    selected: true,
                    selectedIds: vals,
                };
            } else {
                if (this["selectedIds"]) {
                    p["selectedInfo"] = {
                        selected: true,
                        selectedIds: this["selectedIds"],
                    };
                }
            }
        }

        this.showLoading();
        this.hasError = false;
       
        this.httpMgr.lookupRequest(p, t).pipe(
            map((restData: LookupGridResult) => {
                if (restData) {
                    restData.selectedItems = restData["selectedData"] || [];
                } else {
                    if (restData && typeof restData === "object") {
                        restData.selectedItems = [];
                    }
                }
                return restData === null ? false : restData;
            }),
            switchMap((res: LookupGridResult) => {
                if (this.beforeLoadData) {
                    return this.beforeLoadData({instance: this, res});
                }
                return of(res);
            })
        ).subscribe(observer);
    }

    loadData(resData?: LookupGridResult, rebindEvent = true) {
        if (this.activeTab === "datalist") {
            if (this.useFavorite && !this.isTree()) {
                this.favHelper.updateFavoritesStatus(resData.items);
            }

            switch (this.displayType) {
                case LookupGridDisplayType.NavList:
                case LookupGridDisplayType.NavTreeList:
                case LookupGridDisplayType.List:
                    this.loadDataTableData(resData);
                    if (rebindEvent) {
                        this.dtEventMgr.bindDataTableEvent();
                    }
                    break;
                case LookupGridDisplayType.TreeList:
                case LookupGridDisplayType.NavListTree:
                    this.loadTreeTableData(resData, rebindEvent);
                    break;
            }
        } else if (this.activeTab === "favorite") {
            this.loadFavData(resData);
        }

        // éä¸­æ°æ®
        this.selectionMgr.selectCurrentValue();
    }

    private loadFavData(result: LookupGridResult) {
        // å è½½æ¶èæ°æ®
        if (this.useFavorite) {
            if (this.isTree()) {
                this.setTreeInfo(result);
                const treeNodes = this.favHelper.initFavoriteTreeData(
                    result.items
                );
                const treeData = this.treeNodeHelper
                    .flatTreeNodes(treeNodes)
                    .map((n) => {
                        n.data["_addtional_"] = n["addtional"];
                        return n.data;
                    });
                this.lookupSelectionSer.initFavoriteItems(treeData);

                setTimeout(() => {
                    this.favoritesComponentRef.instance.scrollToY(1);
                });
            } else {
                this.lookupSelectionSer.initFavoriteItems(result.items);
            }

            this.favHelper.loadFavoritesData(result);
        }
    }

    loadDataTableData(resData?: LookupGridResult) {
        if (resData) {
            if (this.useFavorite && !this.isTree()) {
                this.favHelper.updateFavoritesStatus(resData.items);
            }
            if (this.gridOptions) {
                if (resData && resData.columns && resData.columns.length) {
                    if (
                        !this.gridOptions.columns ||
                        !this.gridOptions.columns.length
                    ) {
                        this.columns = resData.columns;
                    }
                }

                this.items = resData.items;
                this.total = resData.total || resData.items.length;
                // if ( resData.searchFields ) {
                //     this.gridOptions.searchFields = this.getSearchColumns(resData);
                // }
                if (resData.pageInfo) {
                    if (
                        resData.pageInfo.pageList &&
                        (!this.pageList || !this.pageList.length)
                    ) {
                        this.pageList = resData.pageInfo.pageList;
                    }
                    this.pagination = resData.pageInfo.enablePager;
                    this.pageIndex = resData.pageInfo.pageIndex;
                    this.pageSize = resData.pageInfo.pageSize;
                } else {
                    this.pagination = false;
                }
            } else {
                this.gridOptions = resData as LookupGridOptions;
            }
        }

        this.updateDataTable(this.gridOptions);
    }

    private updateDataTable(opts: any) {
        if (opts && this.componentRef ) {
            const dt = this.componentRef.instance as DataTableComponent;

            if (!dt.columns || dt.columns.length === 0) {
                dt.columns = this.gridOptions.columns;
            }
            dt.allColumnsTitle = this.allColumnsTitle;
            dt.searchFields = opts.searchFields;
            dt.pagination = opts.pagination;
            dt.pageList = this.pageList;
            dt.remoteSort = this.remoteSort;
            dt.striped = this.enableMultiFieldSearch;

            if (this.loadDataWhenOpen) {
                dt.loadData({
                    pageSize: opts.pageSize,
                    pageIndex: this.gridOptions.pageIndex,
                    total: this.gridOptions.total,
                    data: this.gridOptions.items,
                });
                dt.cd.markForCheck();
            }
            this.loadSuccess.emit();
        }
    }

    private setTreeInfo(resData) {
        if (!resData) {
            return;
        }

        let _treeInfo = null;
        if (resData.treeInfo) {
            const onlySelectLeaf = resData.treeInfo.onlySelectLeaf;
            let _osl: ONLY_SELECT_LEAF = "no";
            if (onlySelectLeaf !== undefined) {
                _osl = onlySelectLeaf ? "yes" : "no";
            }
            _treeInfo = { ...resData.treeInfo, onlySelectLeaf: _osl };
        }

        const treeInfo = this.gridOptions.treeInfo;
        if (treeInfo) {
            if (
                treeInfo.onlySelectLeaf === undefined ||
                treeInfo.onlySelectLeaf === null
            ) {
                treeInfo.onlySelectLeaf = "no";
            }

            if (typeof treeInfo.onlySelectLeaf === "boolean") {
                treeInfo.onlySelectLeaf = treeInfo.onlySelectLeaf ? "yes" : "no";
            }

            // 20210902
            if (this.loadTreeDataType === "default") {
                treeInfo.loadDataType = _treeInfo.loadDataType;
            } else {
                treeInfo.loadDataType = this.loadTreeDataType === "loadall" ? "all" : "async";
                _treeInfo.loadDataType = treeInfo.loadDataType
            }

            if (treeInfo.onlySelectLeaf !== "default") {
                _treeInfo = Object.assign(_treeInfo, treeInfo);
            }
        } else {
            if (this.loadTreeDataType !== "default") {
                _treeInfo.loadDataType = this.loadTreeDataType === "loadall" ? "all" : "async";
            }
        }

        this.treeInfo = _treeInfo;
    }

    private loadTreeTableData(resData?: LookupGridResult, rebindEvent = true) {
        const items = resData ? resData.items : this.gridOptions.items;
        this.items = items;

        if (resData) {
            this.setTreeInfo(resData);

            const treeInfo = this.gridOptions.treeInfo;
            if (!treeInfo["treeDataIsInit"]) {
                if (treeInfo.layerType.toLowerCase() === "pathcode") {
                    this.items = this.lookupUtils.makeTree(
                        this.items,
                        treeInfo
                    );
                } else {
                    this.items = this.lookupUtils.makeTreeWithParentID(
                        this.items,
                        "",
                        treeInfo.dataField ? `${treeInfo.dataField}.${treeInfo.parentField}`: treeInfo.parentField,
                        this.idField
                    );
                }
            }
        }

        if (this.componentRef.instance instanceof TreeTableComponent) {
            const tt = this.componentRef.instance as TreeTableComponent;
            if (this.treeInfo) {
                tt.loadDataType = this.treeInfo.loadDataType;
            }

            if (!this.columns || !this.columns.length) {
                tt.columns = resData.columns || [];
                this.gridOptions.columns = tt.columns;
            }

            const isLoadAllTreeData = () => {
                if (this.loadTreeDataType === "default") {
                    return tt.loadDataType === "all";
                } else {
                    return this.loadTreeDataType === "loadall";
                }
            };

            if (rebindEvent) {
                this.ttEventMgr.bindTreetableEvent();
            }
            const isLoadAll = isLoadAllTreeData();

            /** å®æ´æ èç¹æ£æ¥ By Lucas 20200302 */
            
            this.items = this.checkNodeCanBeSelect(this.items, isLoadAll);
            // tfs 670429
            if (tt.searchData.value && this.items && this.items.length) {
                this.items = this.expandFirstNode(this.items);
            }

            tt.keepSelect = true;

            if (this.useFavorite) {
                this.favHelper.updateFavoritesStatus(this.items);
            }

            if (this.loadDataWhenOpen) {
                tt.loadData(this.items);
            }
            tt.resize();
        }
    }

    /**
     * å¨æå®æ´æ ä¸­ï¼æé¨åèç¹å ä¸ºæ¡ä»¶è¢«è¿æ»¤ï¼ä¸ºæ¾ç¤ºå®æ´æ ï¼
     * è¿äºèç¹å¨è¿è¡æ¶æ¯ä¸åè®¸è¢«éä¸­ç, è¿åæ°çèç¹æ°ç»
     * By Lucas 20200302
     */
    checkNodeCanBeSelect(nodes, isAllTreeData = false): TreeNode[] {
        if (nodes && nodes.length) {
            return nodes.map((node: TreeNode) => {
                if (node.hasOwnProperty("addtional")) {
                    node.selectable = !node["addtional"];
                }

                if (node.children && node.children.length) {
                    this.checkNodeCanBeSelect(node.children, isAllTreeData);
                } else {
                    if (isAllTreeData && (!this._searchState || !this._searchState.value)) {
                        node.leaf = true;
                    }
                }

                return node;
            });
        }
        return nodes;
    }

    onChanges(val) {
        if (!val) {
            this.onClear();
        } else {
            this.displayText = val;
            this.isTextChange = this.originalText !== this.displayText;
            if (this.nosearch) {
                this.setModelValue(val);
                this.clearMappings.emit({ instance: this, value: val, });
            }

            this.onModelTouched(val);
            this.valueChanged.emit(val);
            this.textChanged.emit(val);
        }
    }


    onClear(emit = true) {
        this.isTextChange = false;
        this.displayText = "";
        this.displayValue = "";
        this.originalText = "";
        this.extendInfo = "";
        this.setModelValue("");
        if (this.mappingFn) {
            this.mappingFn(null, this.mapFields);
        } else {
            if (this.mapFields) {
                const bindingData = this.selectionMgr.getBindingData();
                if (bindingData) {
                    this.defaultMapping.lookupFieldMap(
                        null,
                        this.mapFields,
                        bindingData
                    );
                }
            }
        }
        this.multiSelMgr.clear();
        if (emit) {
            this.clear.emit();
        }
    }

    clearValue(emit = true) {
        this.onClear(emit);
    }

    selectItem(rowData?: any) {
        let selectedRow = null;
        if (rowData) {
            selectedRow = rowData;
        } else {
            selectedRow = this.selections;

            if (!selectedRow) {
                selectedRow = null;
            } else {
                if (Array.isArray(selectedRow) && !selectedRow.length) {
                    selectedRow = null;
                }
            }
        }

        this._searchState = { 
            field: '*',
            value: ''
        }

        // å¦æå®ä¹äºèªå®ä¹å¤çç¡®å®äºä»¶ï¼åç±èªå®ä¹äºä»¶å¤çåé¢çé»è¾
        if (this.okHandler) {
            this.okHandler({ data: selectedRow, instance: this });
        } else {
            if (this.beforeSelectData) {
                const bsdResult = this.beforeSelectData({
                    instance: this,
                    data: selectedRow,
                });
                if (bsdResult && bsdResult.subscribe) {
                    bsdResult.subscribe((e: any) => {
                        this._beforeSelectDataCallBack(e, selectedRow);
                    });
                } else {
                    this.writeConsole('å¸®å©æ°æ®éä¸­åäºä»¶æªè¿åå¼æè¿åç±»åéObservable, è¯·æ£æ¥', 'error');
                }
            } else {
                this._beforeSelectDataCallBack(true, selectedRow);
            }
        }
    }

    getPathCode(data, treeInfo = null) {
       return this.lookupUtils.getPathCode(data, treeInfo || this.treeInfo);
    }
    getLayerData(data, treeInfo = null) {
        return this.lookupUtils.getLayerData(data, treeInfo || this.treeInfo);
    }


    private getParentPathCode(rows) {
        const maxBy = (arr, fn) =>
            Math.max(
                ...arr.map(typeof fn === "function" ? fn : (val) => val[fn])
            );

        // const { dataField, pathField, layerField } = this.treeInfo;
        const maxLayer = maxBy(rows, (x) => this.getLayerData(x));

        for (let i = 1; i <= maxLayer; i++) {
            const _rows = rows.filter((n) => this.getLayerData(n) === i);
            if (_rows && _rows.length && _rows.length < rows.length) {
                _rows.forEach((r) => {
                    const patchCode = this.getPathCode(r);
                    const _rows2 = rows.filter(
                        (n) => {
                            var _pc = this.getPathCode(n);
                            return _pc !== patchCode && _pc.indexOf(patchCode) === 0;
                        }
                    );
                    if (_rows2 && _rows2.length) {
                        rows = rows.filter(
                            (n) => this.getPathCode(n) !== patchCode
                        );
                    }
                });
            }
        }

        return rows;
    }

    private _beforeSelectDataCallBack(e, selectedRow) {
        let canSelect = e;
        let message = "";
        if (typeof e === "boolean") {
            canSelect = e;
        } else {
            if (typeof e === "object") {
                canSelect = e.canSelect;
                message = e.message;
            } else {
                canSelect = false;
            }
        }

        if (!selectedRow) {
            message = this.mustChoosAdatarow;
            canSelect = false;
        }

        if (canSelect) {
            let selectedRows$ = of(selectedRow);
            // å¤é æ å¸®å© å¼æ­¥å è½½ åçº§ç  å¼å¯åæ­¥éæ© æåå«ä¸çº§
            if (!this.singleSelect && this.enableCascade && this.isTree() ) {
                if (this.treeInfo.loadDataType !== "all" && this.treeInfo.layerType === "pathcode" && this.isGetAllChidlNodes) {
                    let parentsIds = this.getParentPathCode(selectedRow);
                    if (parentsIds && parentsIds.length) {
                        parentsIds = parentsIds.map(
                            (n) => this.getPathCode(n)
                        );
                        this.showLoading();
                        selectedRows$ = this.httpMgr
                            .getData({ parentsIds }, "allChildren")
                            .pipe(
                                map((r: LookupGridResult) => {
                                    const items = r.items
                                        ? r.items.map((d) => d.data)
                                        : [];
                                    const allitems = [...selectedRow, ...items];
                                    let ids = allitems.map((n) => n[this.idField]);
                                    ids = Array.from(new Set(ids));
                                    return ids.map((n) =>
                                        allitems.find((a) => a[this.idField] === n)
                                    );
                                })
                            );
                    }
                }
            }

            selectedRows$.subscribe((rows) => {
                this.closeLoading();
                if (this.isGetAllChidlNodes) {
                    this.lookupSelectionSer.loadSelections(rows);
                }
                this.updateControlValue(rows);
                if (!this.useTip || !rows) {
                    return;
                }
                if (this.useTip) {
                    this.personalConfigService.updateQueckSelected(
                        rows,
                        this.localService.localeId
                    );
                }
            });
        } else {
            if (message) {
                if (this.notifyService) {
                    this.notifyService.warning(message);
                } else {
                    this.messagerService.warning(message, "", true, () => {
                        this.dialog.el.nativeElement.click();
                    });
                }
            }
        }
    }

    private updateControlValue(selectedRow) {
        if (selectedRow) {
            this.setDisplayText(selectedRow);
            if (this.mappingFn) {
                this.mappingFn(selectedRow, this.mapFields, this.bindingData);
            } else {
                if (this.mapFields && this.bindingData) {
                    this.defaultMapping.lookupFieldMap(
                        selectedRow,
                        this.mapFields,
                        this.bindingData
                    );
                }
            }
            this.setModelValue(this.displayText);
            if (this["inDatagrid"] && selectedRow) {
                const selectItems = Array.isArray(selectedRow)
                    ? selectedRow
                    : [selectedRow];
                this.updateBindData(selectItems);
            }
            this.selectedData.emit(selectedRow);
            this.runDictPickedEvent(selectedRow);
            this.isTextChange = false;
        } else {
            if (document.activeElement) {
                (document.activeElement as HTMLButtonElement).blur();
            }
            this.messagerService.warning(this.mustChoosAdatarow);
        }
    }

    private updateBindData(selectedRow) {
        if (!this.mapFields) {
            return;
        }

        const helpFields = Object.keys(this.mapFields);
        if (
            this.ngControl &&
            this.ngControl.formDirective &&
            this.ngControl.formDirective.form &&
            this.ngControl.formDirective.form.bindingData
        ) {
            const bindingData = this.ngControl.formDirective.form.bindingData;

            if (bindingData) {
                helpFields.forEach((helpField: any) => {
                    this.mapFields[helpField]
                        .split(",")
                        .forEach((formField: any) => {
                            const val = selectedRow
                                .map((r) => {
                                    return this.utils.getValue(helpField, r);
                                })
                                .join(this.multipleChoiceSeparator);
                            this.utils.setValue(bindingData, formField, val);
                        });
                });
            }

            // if (bindingData.setValue) {
            //     const bindingPath = this.ngControl.formDirective.form.bindingPath;
            //     let pathArr: string[] = [];
            //     if (bindingPath) {
            //         pathArr = bindingPath.split('/').filter(n => n !== '');
            //     }

            //     helpFields.forEach((helpField: any) => {
            //         this.mapFields[helpField].split(',').forEach((formField: any) => {
            //             const fieldPaths = pathArr.concat(formField.split('.'));
            //             const val = selectedRow.map(r => {
            //                 return this.utils.getValue(formField, r);
            //             }).join(this.multipleChoiceSeparator);
            //             bindingData.setValue(pathArr.concat(fieldPaths), val, true, true);
            //         });
            //     });
            // }
        } else {
            // if (this.bindingData) {
            //     helpFields.forEach((helpField: any) => {
            //         this.mapFields[helpField].split(',').forEach((formField: any) => {
            //             const val = selectedRow.map(r => {
            //                 return this.utils.getValue(formField, r);
            //             }).join(this.multipleChoiceSeparator);
            //             this.utils.setValue(this.bindingData, formField, val);
            //         });
            //     });
            // }
        }
    }

    private getExtendInfoFields(isHelpData = true) {
        if (!this.extInfoFields) {
            this.writeConsole(`æªè®¾ç½®æ©å±å­æ®µã`);
            return [];
        }
        const tipFieldArr = this.extInfoFields.split(",");

        if (isHelpData) {
            let extendInfoFields = [];
            extendInfoFields = tipFieldArr.map((tf) => {
                const mapKey = Object.keys(this.mapFields).find((k) => {
                    return this.mapFields[k] === tf;
                });

                if (mapKey) {
                    return mapKey;
                } else {
                    this.writeConsole(`å¨å¸®å©æ å°å­æ®µä¸­æªæ¾å°${tf}`);
                    return "";
                }
            });
            return extendInfoFields;
        }

        return tipFieldArr;
    }

    onUpdateExtendInfo() {
        const jsonData = this.selectionMgr.getBindingData();
        this.updateExtendInfo(jsonData, false);
    }

    // éä¸­å¸®å©æ°æ®åï¼æ´æ°æ©å±ä¿¡æ¯
    private updateExtendInfo(data: any, isHelpData = true) {
        if (data) {
            if (this.extInfoFormatter) {
                if (Array.isArray(data)) {
                    const tipString = data.map((n) => {
                        return this.getExtendInfoText(n);
                    });
                    this.extendInfo = tipString.join("ï¼");
                } else {
                    this.extendInfo = this.getExtendInfoText(data);
                }
            } else {
                const extendInfoFields = this.getExtendInfoFields(isHelpData);
                if (extendInfoFields && extendInfoFields.length) {
                    if (Array.isArray(data)) {
                        const tipString = data.map((n) => {
                            return this.getExtendInfoText(n, extendInfoFields);
                        });
                        this.extendInfo = tipString.join("ï¼");
                    } else {
                        this.extendInfo = this.getExtendInfoText(
                            data,
                            extendInfoFields
                        );
                    }
                }
            }
        }
    }

    private getExtendInfoText(itemData, fields = null) {
        if (typeof this.extInfoFormatter === "function") {
            return this.extInfoFormatter({
                bindingData: itemData,
                instance: this,
            });
        } else {
            const tipString = [];
            const tipValues = fields.map((t) => {
                const tfv = this.utils.getValue(t, itemData);
                tipString.push(tfv);
                return { [t]: tfv };
            });
            return tipString.join(" ");
        }
    }

    private getDisplayText(rows: any) {
        const df = this.displayFields
            ? this.displayFields.split(",")
            : [this.textField];
        const txtArr = rows.map((r) => {
            const t = [];
            df.forEach((n) => {
                t.push(this.utils.getValue(n, r));
            });
            return t.join(this.displayTextSeparator);
        });

        if (this.gridOptions.singleSelect) {
            return txtArr.join("");
        } else {
            if (this.displayFields) {
                return txtArr.map((t) => "[" + t + "]").join(this.multipleChoiceSeparator);
            } else {
                return txtArr.join(this.multipleChoiceSeparator);
            }
        }
    }

    private setDisplayText(selectedRow: any) {
        this.originalText = this.displayText;

        if (this.gridOptions.singleSelect) {
            if (this.displayFormatter) {
                this.displayText = this.utils.getValue(
                    this.textField,
                    selectedRow
                );
                if (!this.isTree()) {
                    this.displayText = this.displayFormatter(
                        this.displayText,
                        [selectedRow],
                        {
                            lookup: this,
                            datatable: this.componentRef
                                .instance as DataTableComponent,
                        }
                    );
                } else {
                    const tt = this.componentRef.instance as TreeTableComponent;
                    this.displayText = this.displayFormatter(
                        this.displayText,
                        [selectedRow],
                        { lookup: this, tree: tt }
                    );
                }
            } else {
                this.displayText = this.getDisplayText([selectedRow]);
            }
            this.displayValue = selectedRow[this.valueField || this.idField];
        } else {
            if (selectedRow.length) {
                if (this.displayFormatter) {
                    this.displayText = selectedRow
                        .map((r) => {
                            return this.utils.getValue(this.textField, r);
                        })
                        .join(this.multipleChoiceSeparator);
                    if (!this.isTree()) {
                        this.displayText = this.displayFormatter(
                            this.displayText,
                            selectedRow,
                            {
                                lookup: this,
                                datatable: this.componentRef
                                    .instance as DataTableComponent,
                            }
                        );
                    } else {
                        const tt = this.componentRef
                            .instance as TreeTableComponent;
                        this.displayText = this.displayFormatter(
                            this.displayText,
                            selectedRow,
                            { lookup: this, tree: tt }
                        );
                    }
                } else {
                    this.displayText = this.getDisplayText(selectedRow);
                }

                this.displayValue = selectedRow
                    .map((r) => {
                        return this.utils.getValue(this.valueField || this.idField, r);
                    })
                    .join(this.multipleChoiceSeparator);
            }
        }
        this.originalText = this.displayText;
    }

    runDictPickedEvent(rowData: any) {
        if (this.dictPicked) {
            if (this.okButton) {
                this.okButton.nativeElement.disabled = true;
            }
            this.dictPickedSubscription = this.dictPicked(rowData).subscribe(
                (v: any) => {
                    if (this.okButton) {
                        this.okButton.nativeElement.disabled = false;
                    }
                    if (typeof v === "boolean") {
                        if (v) {
                            this.closeDialog(rowData);
                        }
                    } else if (
                        typeof v === "object" &&
                        v.closeDialog !== undefined &&
                        !v.closeDialog
                    ) {
                        if (v.message) {
                            this.messagerService.warning(v.message);
                        } else {
                            this.closeDialog(rowData);
                        }
                    } else {
                        this.closeDialog(rowData);
                    }
                }
            );
        } else {
            this.closeDialog(rowData);
        }
    }

    private focusToInput(): void {
        this.zone.runOutsideAngular(() => {
            setTimeout(() => {
                if (this.inputGroup && this.inputGroup.textbox) {
                    this.inputGroup.textbox.nativeElement.focus();
                }
            });
        });
    }

    closeDialog(rowData = null) {
        if (this.dialog) {
            this.dialog.close();
        }
        
        if (rowData) {
            this.multiSelMgr.save(rowData);
        }
        
        // this.isShow = false;
        this.focusToInput();
    }

    cancelSelect() {
        this.closeDialog();
        this.isTextChange = false;
        if (!this.nosearch) {
            this.displayText = this.originalText;
            this.setModelValue(this.displayText);
        }

        if (this.cancelHandler) {
            this.cancelHandler(this);
        }
    }

    setModelValue(v) {
        if (this.onModelChange) {
            this.onModelChange(v);
            this.valueChanged.emit(v);
        }
    }

    // æ°æ®åè¡¨ï¼æ¶èï¼ å·²éæ°æ® tab é¡µåæ¢
    onTabChange(e: any) {
        this.activeTab = e.tabIndex;
        this.personalConf.tabIndex = this.activeTab;
        const _firstChange = this.isTabChanged;
        this.isTabChanged = true;
        this.personalConfigService.updatePersonalConfig({
            tabIndex: e.tabIndex,
        });

        if (this.activeTab === "datalist") {
            if (this.isDoublleList() && !this.leftComponentRef) {
                if (this.navigationOptions) {
                    this.lookupCmpMgr.createLeftComponent(
                        this.navigationOptions
                    );
                } else {
                    this.initData();
                    return;
                }
            }

            if (!this.items || !this.items.length) {
                this.initData();
            } else {
                if (!_firstChange) {
                    if (this.isTree()) {
                        this.loadTreeTableData();
                    } else {
                        this.loadDataTableData();
                        this.dtEventMgr.bindDataTableEvent();
                    }
                }
                // this.selectionMgr.selectCurrentValue();
            }
            this.showGetAllChildrenCheckbox();
        } else {
            if (this.activeTab === "favorite") {
                if (this.isTree()) {
                    this.initData();
                } else {
                    if (
                        !this.favoriteItems ||
                        !this.favoriteItems.length ||
                        this.favoriteItems.length !== this.favHelper.getFavoritIds().length
                    ) {
                        this.initData();
                    } else if (!_firstChange) {
                        this.favHelper._loadFavoriteData(this.favoriteItems);
                        // this.selectionMgr.selectCurrentValue();
                    }
                    //  else {
                    //     this.selectionMgr.selectCurrentValue();
                    // }
                }
            }
        }

        this.changeDetector.detectChanges();
        setTimeout(() => {
            this.resizeCmp();
            if (this.isTree()) {
                const y = this.componentRef.instance.state.scrollY;
                this.componentRef.instance.scrollToY(y, 0);

                if (this.enableCascade) {
                    this.ttEventMgr.cascadeValueChanged(this.cascadeStatus);
                }
            }

            if (this.isDoublleList() && this.displayType === LookupGridDisplayType.NavTreeList && !this.navTreeToList) {
                this.leftComponentRef.instance.updateScrollPosition(); 
            }
            this.selectionMgr.selectCurrentValue();
        });
    }

    //#region  Tag View ----------------------------------------------------------------------
    private registerMouseEventForTagView() {
        if (this.enableClear) {
            this.tagbox.nativeElement.addEventListener(
                "mouseenter",
                this.onTagboxMouseEnter.bind(this)
            );
            this.tagbox.nativeElement.addEventListener(
                "mouseleave",
                this.onTagboxMouseLeave.bind(this)
            );
        }
    }

    private toggleClearIcon(event: any, isShow = false) {
        const str = isShow ? "" : "none";
        const clearIcon = event.target.querySelector(".input-group-clear");
        if (clearIcon) {
            clearIcon.style.display = str;
        }
    }

    private onTagboxMouseEnter(event) {
        if (this.displayText && this.enableClear) {
            if (!this.readonly && !this.disabled) {
                this.showTagboxClearButton = true;
            }
        }
        if (this.showTagboxClearButton) {
            this.toggleClearIcon(event, true);
        }
    }

    private onTagboxMouseLeave(event) {
        this.toggleClearIcon(event);
    }

    onRemoveSelectItem($event, txt) {
        $event.stopPropagation();
        const textArray = Array.from(this.displayTextList);
        const removedIndex = this.displayTextList.indexOf(txt);
        textArray.splice(removedIndex, 1);
        this.displayText = textArray.join(this.multipleChoiceSeparator);
        this.originalText = this.displayText;
        this.setModelValue(this.displayText);


        if (this.displayValue) {
            const vals = this.displayValue.split(this.multipleChoiceSeparator);
            vals.splice(removedIndex, 1);
            this.displayValue = vals.join(this.multipleChoiceSeparator);
        }

        if (this.mapFields) {
            this.updateOtherFieldDataWhenTagremoved(removedIndex);
        }

        this.tagRemoved.emit({ removedIndex, instance: this });
    }

    private updateOtherFieldDataWhenTagremoved(removedIndex) {
        const helpFields = Object.keys(this.mapFields);
        const textFieldIndex = helpFields.indexOf(this.textField);

        if (
            this.ngControl &&
            this.ngControl.formDirective &&
            this.ngControl.formDirective.form &&
            this.ngControl.formDirective.form.bindingData
        ) {
            const bindingData = this.ngControl.formDirective.form.bindingData;
            if (bindingData.setValue) {
                const bindingPath =
                    this.ngControl.formDirective.form.bindingPath;
                let pathArr: string[] = [];
                if (bindingPath) {
                    pathArr = bindingPath.split("/").filter((n) => n !== "");
                }

                helpFields.forEach((helpField: any) => {
                    this.mapFields[helpField]
                        .split(",")
                        .forEach((formField: any) => {
                            const fieldPaths = pathArr.concat(
                                formField.split(".")
                            );
                            const val = bindingData.getValue(fieldPaths);
                            const valArr = val.split(
                                this.multipleChoiceSeparator
                            );
                            valArr.splice(removedIndex, 1);
                            const newVal = valArr.join(
                                this.multipleChoiceSeparator
                            );
                            bindingData.setValue(
                                pathArr.concat(fieldPaths),
                                newVal,
                                true,
                                true
                            );
                        });
                });
            }
        } else {
            if (this.bindingData) {
                if (textFieldIndex > -1) {
                    helpFields.splice(textFieldIndex, 1);
                }
                helpFields.forEach((helpField: any) => {
                    this.mapFields[helpField]
                        .split(",")
                        .forEach((formField: any) => {
                            const val = this.utils.getValue(
                                formField,
                                this.bindingData
                            );
                            const valArr = val.split(
                                this.multipleChoiceSeparator
                            );
                            valArr.splice(removedIndex, 1);
                            const newVal = valArr.join(
                                this.multipleChoiceSeparator
                            );
                            this.utils.setValue(
                                this.bindingData,
                                formField,
                                newVal
                            );
                        });
                });
            }
        }
    }
    //#endregion

    onAllChildNodesClick($event: any) {
        this.isGetAllChidlNodes = $event;
        this.personalConf['useGetAllChilds'] = this.isGetAllChidlNodes;
    }

    onIncludeSubordinatesChange(val) {
        this.includeSubordinates = val;
        this.includeSubordinates$.next(val);
    }

    onTagContainerClick($event: MouseEvent) {
        $event.stopPropagation();
        if (this.tagInput) {
            this.tagInput.focus();
            this.tagInput.textbox.nativeElement.click();
        }
    }

    expandFirstNode(nodes): TreeNode[] {
        if (nodes && nodes.length) {
            return nodes.map((node: TreeNode) => {
                if (node.children && node.children.length) {
                    node.expanded = true;
                    this.expandFirstNode(node.children);
                }
                return node;
            });
        }
        return nodes;
    };

    // ç¨äºç»ç»ä¸ªæ§åæ°æ®key
    getLookupBindingFields() {
        if (this.ngControl) {
            if (this.ngControl.name) {
                return this.ngControl.name;
            } else {
                if (this.mapFields && this.mapFields.length) {
                    return Object.keys(this.mapFields).map(k => {
                        return this.mapFields[k];
                    }).join('_');
                } else {
                    return this.textField;
                }
            }
        } else {
            return '';
        }
    }

    onConditionsChange($event) {
        if (this.isTree() ) {
            this.ttEventMgr.conditionsChange($event);
        } else {
            this.dtEventMgr.conditionsChange($event);
        }
    }

    clearSelected($event: MouseEvent) {
        if($event) {
            $event.stopPropagation();
        }

        const msg = this.localService.getValue('lookup.selectedInfo.confirm');

        this.messagerService.confirm(msg || 'æ¨ç¡®è®¤è¦åæ¶ææå·²éä¸­çè®°å½åï¼').subscribe((e) => {
            if (e) {
                this.multiSelMgr.clear();
                if (this.selectedDtRef) {
                    this.selectedDtRef.clearSelections();
                } 
            }
        });
    }

    onDeleteSelectedItem($event: MouseEvent) {
        if($event) {
            $event.stopPropagation();
        }

        if (this.selectedDtRef.selections && this.selectedDtRef.selections.length) {
            const unCheckeIds = this.selectedDtRef.selections.map(n => n[this.idField]);
            this.multiSelMgr.deleteSelectedItems(this.selectedDtRef.selections);
            this.selectedDtRef.unCheckRows(unCheckeIds);
        } else {
            this.notifyService.warning('è¯·å¾éè¦å é¤çè®°å½ï¼');
        }
    }

    initColumnWidth(columns: any, typ: 'data'|'nav'|'fav'|'sel' = 'data') {
        if (this.personalConf && this.personalConf.colSizeInfo && this.personalConf.colSizeInfo.data) {
            const fieldsizeData = this.personalConf.colSizeInfo[typ];
            if(fieldsizeData) {
                const fields = Object.keys(fieldsizeData);
                if (fields && fields.length) {
                    columns.forEach(n => {
                        if (fieldsizeData[n.field]) {
                            n.width = fieldsizeData[n.field];
                        }
                    })
                }
            }
        }
    }
}
